import styled from 'astroturf/react'
import { TimezoneIcon } from '@calendly/ui/components/icons'
import { getTimezoneName } from '@calendly/timezone-tools'
const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
import { DetailsItem as Item } from '@calendly/booking-kit'
import _TimezoneName from "timezone-TimezoneName.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/details/timezone.js?styleId=TimezoneName";


const TimezoneName = /*#__PURE__*/styled('span', null, {
  displayName: "TimezoneName",
  styles: _TimezoneName
})

export default ({ value }) => (
  <Item>
    <TimezoneIcon size="large" spacingRight={8} data-id="details-item-icon" />
    <TimezoneName>{getTimezoneName(value)}</TimezoneName>
  </Item>
)
